import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { AddressBookHoldModalComponent } from "../address-book-hold-modal/address-book-hold-modal.component";
import { AddressBookHoldModalV2Component } from "../address-book-hold-modal-v2/address-book-hold-modal-v2.component";
import {
	AddressBookWalletTransactionData,
	OnHoldWalletSelection
} from "@modules/main/components/address-book-wallet/model/address-book-wallet.model";
import { AddressBookWalletService } from "@modules/main/components/address-book-wallet/services/address-book-wallet.service";
import { CustomModal } from "@modules/core/components/base-modals";
import { Data, Router } from "@angular/router";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";

@Component({
	selector: "app-deposit-on-hold-wallet-type-modal",
	templateUrl: "./deposit-on-hold-wallet-type-modal.component.html",
	styleUrl: "./deposit-on-hold-wallet-type-modal.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositOnHoldWalletTypeModalComponent extends CustomModal implements OnInit {
	@Input() data: Data;

	public onHoldWalletSelection = OnHoldWalletSelection;
	public hasWalletHost: boolean = false;
	private transactionId: string = "";
	private addressBookId: string = "";
	private isTravelRuleV2Enabled: boolean = false;
	private SHW3rdPartyDisabled: boolean = false;

	constructor(
		private readonly walletService: AddressBookWalletService,
		private readonly cdr: ChangeDetectorRef,
		private readonly universalModalService: UniversalModalService,
		private readonly router: Router
	) {
		super();
	}

	ngOnInit(): void {
		this.transactionId = this.data?.transactionId;
		this.addressBookId = this.data?.addressBookId;
		this.isTravelRuleV2Enabled = this.data?.isTravelRuleV2Enabled ?? false;
		this.SHW3rdPartyDisabled = this.data?.SHW3rdPartyDisabled ?? false;
		if (this.transactionId) {
			this.walletService.getPaymentTransaction$(this.transactionId).subscribe({
				next: (transaction: AddressBookWalletTransactionData) => {
					this.hasWalletHost = Boolean(transaction?.payment_data?.wallet_host);
					this.cdr.detectChanges();
				}
			});
		}
	}

	public cancel(): void {
		this.modalService.popAll();
		this.universalModalService.close(ModalCloseReason.close);
		if (!this.data?.transactionId && !this.data?.addressBookId) {
			this.router.navigateByUrl("/home");
		}
	}

	public back(): void {
		this.modalService.pop();
		this.universalModalService.close(ModalCloseReason.close);
		if (!this.data?.transactionId && !this.data?.addressBookId) {
			this.router.navigateByUrl("/home");
		}
	}

	public selectOption(modeSelection: OnHoldWalletSelection): void {
		const data = { transactionId: this.transactionId, addressBookId: this.addressBookId };
		this.universalModalService.close(ModalCloseReason.close);
		if (this.isTravelRuleV2Enabled) {
			this.modalService.showModal(AddressBookHoldModalV2Component, {
				...data,
				SHW3rdPartyDisabled: this.SHW3rdPartyDisabled,
				modeSelection
			});
		} else {
			this.modalService.showModal(AddressBookHoldModalComponent, data);
		}
	}
}
